import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Flex, Text, Button, Box } from '@radix-ui/themes';

import AudienceForm from './AudienceForm.jsx';
import RadixDialog from '../../../../shared/RadixDialog/RadixDialog.jsx';

export const EditModal = ({ open, setOpen, item, setItem }) => {
  const { t } = useTranslation(['edit']);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
    setItem(null);
  };

  const title = item
    ? t('edit:audienceForm:edit:title')
    : t('edit:audienceForm:create:title');

  return (
    <>
      <RadixDialog
        isOpen={open}
        onClose={onClose}
        title={
          <Flex align="center" gap="2">
            <Text size="4" weight="medium">
              {title}
            </Text>
            <Button
              type="button"
              variant="soft"
              size="1"
              onClick={() => setInfoDialogOpen(true)}
              style={{ cursor: 'pointer' }}
            >
              <i
                className="fa-solid fa-circle-info"
                style={{ fontSize: '16px' }}
              />
            </Button>
          </Flex>
        }
      >
        {open && <AudienceForm item={item} closeModal={onClose} />}
      </RadixDialog>

      <RadixDialog
        isOpen={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
        title={t('edit:audienceForm.infoDialog.title')}
        zIndex={2000}
      >
        <Flex direction="column" gap="3">
          <Box>
            <Text size="2" style={{ lineHeight: '1.5' }}>
              <strong>{t('edit:audienceForm.infoDialog.orLabel')}</strong>{' '}
              <Trans
                i18nKey="edit:audienceForm.infoDialog.orDescription"
                components={{ 1: <em /> }}
              />
            </Text>
          </Box>
          <Box>
            <Text size="2" style={{ lineHeight: '1.5' }}>
              <strong>{t('edit:audienceForm.infoDialog.andLabel')}</strong>{' '}
              <Trans
                i18nKey="edit:audienceForm.infoDialog.andDescription"
                components={{ 1: <em /> }}
              />
            </Text>
          </Box>
          <Box>
            <Text size="2" style={{ lineHeight: '1.5' }}>
              <strong>{t('edit:audienceForm.infoDialog.exampleLabel')}</strong>{' '}
              <Trans
                i18nKey="edit:audienceForm.infoDialog.exampleDescription"
                components={{
                  1: <strong />,
                  2: <strong />,
                  3: <strong />,
                  4: <strong />,
                }}
              />
            </Text>
          </Box>
        </Flex>
      </RadixDialog>
    </>
  );
};
